<script lang="ts">
import {
  PhxsgIconProps as PhxsgCoreIconProps,
  PhxsgIcon as PhxsgCoreIcon,
} from '@sg-core/src/View/Components/Atoms/Icon';

export type PhxsgIconSize = '2xs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'logo' | 'logo-150' | 'flag' | 'social';

export type PhxsgIconIds =
  | '360'
  | '3d'
  | 'address-book'
  | 'ae'
  | 'ar'
  | 'at'
  | 'au'
  | 'be'
  | 'bell'
  | 'bg'
  | 'box-open'
  | 'br'
  | 'bubble'
  | 'ca'
  | 'calendar'
  | 'ch'
  | 'chat'
  | 'checkmark'
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-left-alt'
  | 'chevron-right'
  | 'chevron-right-alt'
  | 'chevron-up'
  | 'circumference'
  | 'close'
  | 'cm'
  | 'cn'
  | 'cog'
  | 'credit-cards'
  | 'criteria-invalid'
  | 'criteria-item'
  | 'criteria-valid'
  | 'cross'
  | 'cz'
  | 'de'
  | 'dk'
  | 'edit'
  | 'ellipsis'
  | 'engraving'
  | 'es'
  | 'eye-closed'
  | 'eye-open'
  | 'facebook'
  | 'fi'
  | 'filters'
  | 'fr'
  | 'fullscreen'
  | 'gb'
  | 'geolocation'
  | 'gift'
  | 'go'
  | 'google-plus'
  | 'gr'
  | 'gyroscope'
  | 'heart'
  | 'heart-alt'
  | 'heart-full'
  | 'height'
  | 'help'
  | 'high-jewellery'
  | 'hk'
  | 'home'
  | 'hr'
  | 'hu'
  | 'id'
  | 'id-card'
  | 'ie'
  | 'info'
  | 'instagram'
  | 'int'
  | 'it'
  | 'jewellery'
  | 'jp'
  | 'kr'
  | 'kw'
  | 'la'
  | 'line'
  | 'linkedin'
  | 'list'
  | 'logo'
  | 'logo-150'
  | 'lt'
  | 'lu'
  | 'magnifying-glass'
  | 'mail'
  | 'map'
  | 'marker-boutique'
  | 'marker-cluster'
  | 'marker-location'
  | 'marker-reseller'
  | 'menu'
  | 'messenger'
  | 'minus'
  | 'minus-bold'
  | 'move'
  | 'mt'
  | 'my'
  | 'newsletter'
  | 'nl'
  | 'nz'
  | 'orders'
  | 'pause'
  | 'pdf'
  | 'ph'
  | 'phone'
  | 'pin'
  | 'pinterest'
  | 'pl'
  | 'play'
  | 'plus'
  | 'plus-bold'
  | 'plus-thin'
  | 'pointer-down'
  | 'pointer-up'
  | 'pt'
  | 'qa'
  | 'question'
  | 'remove'
  | 'return'
  | 'ro'
  | 'ru'
  | 'sa'
  | 'se'
  | 'sg'
  | 'share'
  | 'shopping-bag'
  | 'sign-out'
  | 'size'
  | 'sk'
  | 'smartphone'
  | 'sort'
  | 'sound'
  | 'sound-mute'
  | 'speaker'
  | 'store'
  | 'stores'
  | 'subtitles'
  | 'surrounded-cross'
  | 'th'
  | 'tiktok'
  | 'truck'
  | 'tw'
  | 'twitter'
  | 'upload'
  | 'us'
  | 'user'
  | 'vn'
  | 'watches'
  | 'wechat'
  | 'wedding'
  | 'weibo'
  | 'whatsapp'
  | 'width'
  | 'world'
  | 'youku'
  | 'youtube'
  | 'zoom'
  | 'zoom-in'
  | 'zoom-out'
  | 'phxsg-arrow-right'
  | 'phxsg-arrow-left'
  | 'phxsg-bag'
  | 'phxsg-chevron-down'
  | 'phxsg-chevron-left'
  | 'phxsg-chevron-right'
  | 'phxsg-download'
  | 'phxsg-heart'
  | 'phxsg-heart-full'
  | 'phxsg-menu'
  | 'phxsg-pin'
  | 'phxsg-search'
  | 'phxsg-user'
  | 'phxsg-play'
  | 'phxsg-pause'
  | 'phxsg-pen'
  | 'phxsg-boutique';

export type PhxsgIconProps = PhxsgCoreIconProps & { id: PhxsgIconIds; size?: PhxsgIconSize };
</script>

<script setup lang="ts">
defineProps<PhxsgIconProps>();
</script>

<template>
  <PhxsgCoreIcon v-bind="$props" />
</template>

<style src="./icon.css" />
